import { useEffect, useState } from 'react';

/**
 * Fit map to the bounds of all visible markers.
 */
function useMarkerBounds(api, markers, fitMarkerBounds) {
  const [markerBounds, setMarkerBounds] = useState();

  useEffect(() => {
    if (fitMarkerBounds && api && markers.length) {
      const bounds = new api.LatLngBounds();

      markers.forEach((marker) => {
        try {
          if (marker.getVisible()) {
            bounds.extend(marker.getPosition());
          }
        } catch (e) {
          //
        }
      });

      setMarkerBounds(bounds);
    }
  }, [api, markers, fitMarkerBounds]);

  return markerBounds;
}

export default useMarkerBounds;
